import React from 'react';
import BaseProtocol from '../Application/BaseProtocol';
import { OTA_PROTOCOL_ITEMS } from './otaProtocolConstants';

const OtaProtocol = ({ targetUserId, onClose }) => {
    return (
        <BaseProtocol
            role="OTA"
            title="OTA JOB DESCRIPTION"
            items={OTA_PROTOCOL_ITEMS}
            apiEndpoint="/job-descriptions"
            fetchEndpoint="/job-descriptions"
            defaultValues={{
                userId: targetUserId
            }}
            onClose={onClose}
        />
    );
};

export default OtaProtocol;
